import * as React from 'react';
import { DealRentButtonContainer } from '../DealRentButton';
import { DealRentEntryToShowButtonContainer } from '../DealRentEntryToShowButton';
import { DealRentModalContainer } from '../DealRentModal';
import { DealRentSendSimilarModalContainer } from '../DealRentSendSimilarModal';
import { DealRentSimilarSuccessModalContainer } from '../DealRentSimilarSuccessModal';
import { DealRentSuccessModalContainer } from '../DealRentSuccessModal';
import { DealRentFailureModalContainer } from '../DealRentFailureModal';
import { DealRentEntryToShowModalContainer } from '../DealRentEntryToShowModal';
import { EntryToShowSuccessModalContainer } from '../EntryToShowSuccessModal';

export const DealRent = () => (
  <>
    <DealRentButtonContainer />
    <DealRentEntryToShowButtonContainer />
    <DealRentModalContainer />
    <DealRentSuccessModalContainer />
    <DealRentFailureModalContainer />
    <DealRentSendSimilarModalContainer />
    <DealRentSimilarSuccessModalContainer />
    <DealRentEntryToShowModalContainer />
    <EntryToShowSuccessModalContainer />
  </>
);
